module.exports = __webpack_public_path__ + "media/country_flags/mz-6097d8b0.png";